import { useMutation } from '@tanstack/react-query'

import { api } from '../../../services/api'

export const useUpdateOnboading = () =>
  useMutation({
    mutationFn: api.auth.updateOnboading,
    mutationKey: ['update-onboading'],
  })
